<template>
    <div :class="['content', data.bIpone ? 'padIpone' : '',!nState ? 'no_state' : '']">
        <div class="logo">
            <img src="~@/assets/images/antV2/scheme/logo.png" alt="" />
        </div>
        <div class="top-header">
            <img src="~@/assets/images/antV2/scheme/scheme_text.png" alt="" />
        </div>
        <div class="address">
            {{ data.reporInfo.address ? data.reporInfo.address : "" }}
        </div>
        <div class="level_nav">
            <div
                :class="[data.nNavindex == index ? item.atcName : item.className]"
                v-for="(item, index) in data.arrNav"
                :key="index"
                @click="getNav(index)"
            >
                {{ item.name }}
            </div>
        </div>
        <div :class="['second_nav']" v-show="data.nNavindex == 0">
            <div
                :class="[data.secondIndex == index ? 'atc_nav_strip' : '']"
                v-for="(item, index) in data.arrErnav"
                :key="index"
                :style="{ width: 100 / data.arrErnav.length + '%' }"
                @click="getAtcStr(item.openIndex, index)"
            >
                {{ item.title }}
            </div>
        </div>
        <div :class="['second_nav_strip']" v-show="data.nNavindex == 0">
            <!-- , data.arrClass[data.secondIndex].leftClass -->
            <div
                :class="['strip']"
                :style="{
                    width: 100 / data.arrErnav.length + '%',
                    left: (100 / data.arrErnav.length) * data.bottomIndex + '%',
                }"
            ></div>
        </div>
        <!-- 冷暖系统 -->
        <div
            :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 0 && data.bShow ? 'noopacit' : '',
            ]"
        >
            <codsystem
                v-if="data.nNavindex == 0 && data.secondIndex == 0"
                :reporInfo.sync="data.reporInfo"
                @sumbitzi="sumbit"
                @getRoom="getRoomfu"
            ></codsystem>
        </div>
        <!-- 水系统 -->
        <div
            :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 1 && data.bShow ? 'noopacit' : '',
            ]"
        >
            <water
                v-if="data.nNavindex == 0 && data.secondIndex == 1"
                :reporInfo.sync="data.reporInfo"
                :bShowWaterText.sync="data.bShowWaterText"
                @sumbitzi="sumbit"
            ></water>
        </div>
        <!-- 新风系统 -->
        <div
            :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 2 && data.bShow ? 'noopacit' : '',
            ]"
        >
            <freshs
                :reporInfo.sync="data.reporInfo"
                :bShowFreshsText.sync="data.bShowFreshsText"
                @sumbitzi="sumbit"
                v-if="data.nNavindex == 0 && data.secondIndex == 2"
            ></freshs>
        </div>
        <!-- Al-Link -->
        <div
            :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 3 && data.bShow ? 'noopacit' : '',
            ]"
        >
            <ailink
                :reporInfo.sync="data.reporInfo"
                :bShowText.sync="data.bShowText"
                @sumbitzi="sumbit"
                v-if="data.nNavindex == 0 && data.secondIndex == 3"
            ></ailink>
        </div>
        <!-- 方案设计 -->
        <div :class="['opacit', data.nNavindex == 1 && data.bShow ? 'noopacit' : '']">
            <design
                :arrVrList.sync="data.arrVrList"
                :nCuiltips="data.reporInfo.compare_index"
                :reporInfo.sync="data.reporInfo"
                :objOffer.sync="data.objOffer"
                v-if="data.nNavindex == 1"
            ></design>
        </div>
        <!-- 经典案例 -->
        <div :class="['opacit', data.nNavindex == 2 && data.bShow ? 'noopacit' : '']">
            <classic
                :arrPos.sync="data.arrPos"
                :arrRanks.sync="data.arrRanks"
                v-if="data.nNavindex == 2"
            ></classic>
        </div>
        <!-- 底部通用 -->
        <!-- 系统介绍 -->
        <div
            class="currency_suggest"
            ref="viedoTop"
            v-if="data.nNavindex == 0 && data.secondIndex == 0"
        >
            <div class="titel">
                系统优势介绍
            </div>
            <div style="padding: 0 12px">
                <ul>
                    <li
                            :class="[data.nPoints == index ? 'click-points' : '']"
                            v-for="(item, index) in data.arrPoints"
                            :key="index"
                            @click="getPoints(index)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
                <div class="video_img">
                    <video
                            :src="data.arrPoints[data.nPoints].arrSonimg[data.nBright].viedoSrc"
                            :poster="data.arrPoints[data.nPoints].arrSonimg[data.nBright].porstImg"
                            id="ckplayer_a1"
                            loop="loop"
                            muted
                            autoplay
                            x5-video-player-type="h5"
                            preload="metadata"
                            playsinline="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            x5-video-orientation="portraint"
                            x5-video-player-fullscreen="true"
                    ></video>
                    <!-- 隐藏预加载 -->
                    <!-- bShowVideo -->
                    <div class="click_img" v-if="data.bShowVideo">
                        <img
                                @click="clickPlay"
                                src="~@/assets/images/antV2/click_play.png"
                                alt=""
                        />
                    </div>
                </div>
                <div class="bright">
                    <div
                            :class="[
                        item.className,
                        data.nBright == index ? 'click-bright' : '',
                        data.nBright == index ? 'no' + item.className : '',
                    ]"
                            v-for="(item, index) in data.arrPoints[data.nPoints].arrBright"
                            @click="getBright(index)"
                            :key="index"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>

        </div>
        <!-- 末端设备选型 -->
        <div class="currency_suggest" v-if="data.nNavindex == 0 && data.secondIndex == 0">
            <div class="titel">
                <span>末端设备选型</span>
            </div>
            <div
                v-for="(item, index) in data.reporInfo.sub"
                :key="index"
                v-show="index < data.nRoomNumber"
            >
                <div class="room_num">
                    <div class="title_xiao_room">
                        {{ item.room | roomNumber }}
                    </div>
                </div>
                <div class="tabe">
                    <div class="tabe_header">
                        <div
                            :class="[
                                'header_nav',
                                index == 0 ? 'header_width_one' : '',
                                index == 1 ? 'header_width_two' : '',
                                index == 2 ? 'header_width_three' : '',
                                index == 3 ? 'header_width_four' : '',
                                index == 4 ? 'header_width_five' : '',
                            ]"
                            v-for="(item, index) in data.arrDeviceNav"
                            :key="index"
                        >
                            {{ item.titel }}
                        </div>
                    </div>
                    <div class="tabe_list">
                        <div
                            class="warp"
                            v-for="(sumitem, sumindex) in item.rooms"
                            v-show="sumitem.product.length"
                            :key="sumindex"
                        >
                            <div class="header_nav header_width_one">
                                {{ sumitem.name }}
                            </div>
                            <div class="header_nav header_width_two">
                                {{ Number(sumitem.area).toFixed(0) }}
                            </div>
                            <div class="header_width_three" ref="htmlHeight">
                                <div
                                    class="warp_conter"
                                    v-for="(
                                        sopitem, sopindex
                                    ) in sumitem.product"
                                    :key="sopindex"
                                >
                                    <div class="shopp_type">
                                        <div v-if="sopitem.mark">
                                            {{ sopitem.mark }}<br />
                                        </div>
                                        <div v-if="sopitem.product_id != 633">
                                            {{ sopitem.goods_name }}
                                        </div>
                                    </div>
                                    <div class="shopp_item">
                                        {{
                                            sopitem.attr_two.length
                                                ? sopitem.attr_two[0].attr_value
                                                : "/"
                                        }}
                                    </div>
                                    <div class="shopp_item">
                                        {{
                                            sopitem.attr_two.length == 2
                                                ? sopitem.attr_two[1].attr_value
                                                : "/"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="btn_gd"
                @click="getGd"
                v-if="data.reporInfo.sub.length > 1 && data.nRoomNumber == 1"
            >
                --&nbsp;点击查看更多&nbsp;--
            </div>
            <div
                class="btn_gd"
                @click="getSqgd"
                v-if="
                    data.reporInfo.sub.length > 1 &&
                    data.reporInfo.sub.length == data.nRoomNumber
                "
            >
                --&nbsp;点击收起更多&nbsp;--
            </div>
            <!-- 点击查看详细末端选型配置清单 -->
            <div class="btn" @click="getEnd">点击查看详细末端选型配置清单</div>
        </div>
        <div class="zh_btn">
            <div class="share_btn" @click="getShare">分享</div>
            <div class="share_btn" v-if="data.objOffer.constructor != Array" @click="getPdf">打印版输出</div>
        </div>
        <div :class="['second_nav_bottom']" v-if="data.nNavindex == 0">
            <div
                :class="[data.bottomIndex == index ? 'atc_nav_strip_bottom' : '']"
                :style="{ width: 100 / data.arrErnav.length + '%' }"
                v-for="(item, index) in data.arrErnav"
                :key="index"
                @click="getAtcStrBottom(item.openIndex, index)"
            >
                {{ item.title }}
            </div>
        </div>
        <!-- loading -->
         <div class="loading" v-if="data.bLoading">
            <div class="logos">
                <img src="@/assets/images/antV2/scheme/logo.png" alt="" />
            </div>
            <div class="speed">
                <div>正在努力生成方案书...</div>
                <div class="speed_tiao">
                    <div class="giao" :style="{ width: data.nLoading + '%' }"></div>
                </div>
            </div>
            <div class="imgBtn" v-if="data.bShowBtn" @click="cXlogin">重新加载</div>
            <div class="shopp_img">
                <img src="@/assets/images/antV2/scheme/dian_icon.png" alt="" />
            </div>
        </div>
        <!-- 名片 -->
        <card
            :bShowCard.sync="data.bShowCard"
            :objSmcode="data.objSmcode"
            :bAgree.sync="data.bAgree"
            :oUserInfo="data.oUserInfo"
            :bCard.sync="data.bCard"
            :reporInfo.sync="data.reporInfo"
        ></card>
        <!-- 分享弹窗 -->
        <share :bShowNrom.sync="data.bShowNrom" :confit="data.confit"></share>
        <!-- 提示转发弹窗 -->
        <!-- <div class="shareTips" v-if="data.bShowTips">请点击右上角···转发哦~</div> -->
        <!-- 末端选型 -->
        <end :bShowEnd.sync="data.bShowEnd" :reporInfo.sync="data.reporInfo"></end>
        <!-- 分享期限设置 -->
        <div class="share_mark" v-if="data.bShowTips">
            <div class="share_tips">
                <div class="share_title">设置有效期</div>
                <div class="validity">
                    方案书预览有效期：<span>{{ num }}天</span>
                </div>
                <div class="progress">
                    <van-slider
                        bar-height="8"
                        :step="100 / 6"
                        button-size="30"
                        v-model="value"
                        @input="onInput"
                        active-color="#6176e8"
                        inactive-color="#DBDBDB"
                    ></van-slider>
                </div>
                <div class="text">*有效期默认为7天*</div>
                <div class="btn">
                    <div @click.stop="comen">确认</div>
                    <div @click.stop="canler">取消</div>
                </div>
            </div>
        </div>
        <!-- 微信环境请用右上角分享 -->
        <div class="wxshare" v-if="wxShareShow" @click="wxShareShow = false">
            <div class="wxContent">
                <img src="@/assets/images/right_jiao_icon.png" alt="" />
                <div class="wxTips">微信环境请点击右上角分享</div>
            </div>
        </div>
        <!-- 当前pdf是否有效 -->
        <div class="overdue" v-if="!nState">
            <div class="overdue_tips">
                <div class="overdue_title">温馨提示</div>
                <div class="overdue_text">
                    此方案书已过期，截至于<span>{{ endTime | getTime }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getWxSingleConfig } from "@/js/wx.js";
import detail from "@/js/detail.js";
import end from "./components/end/index"; //末端选项
import share from "./components/share/index"; //分享
import card from "./components/card/index.vue"; //名片
import classic from "./components/classic/index.vue"; //经典案例
import design from "./components/design/index.vue"; //设计方案
import freshs from "./components/freshs/index.vue"; //新风系统
import ailink from "./components/ailink/index.vue"; //<!-- Al_Link -->
import water from "./components/water/index.vue"; //<!-- 水系统 -->
import codsystem from "./components/codsystem/index.vue"; //<!-- 冷暖系统 -->
import { getRoom } from "@/js/ant/basicinfov2.js";
import { getAttr , noRepeat } from "@/js/ant/scheme.js";
import { arrImageUrl , objData } from "./data/objdata.js";
let arrImage = arrImageUrl();
export default {
    components: {
        share,
        design,
        classic,
        codsystem,
        water,
        freshs,
        ailink,
        card,
        end,
    },
    data() {
        return {
            value: 100, //初始化值
            nValue: 100,
            num: 7, //初始化值
            nNum: 7, //确认值
            bComen: false,
            wxShareShow:false,
            nState:1,//是否有效
            shareKey:"",//分享进来的key
            endTime:'',
            nKey:'',
            data:objData(),
        };
    },
    filters: {
        // 使用es6的padStart()方法来补0
        getTime(timestamp) {
            let zhTime = timestamp.replace(/\-/g, "/");
            let time = new Date(zhTime);
            let year = time.getFullYear();
            const month = (time.getMonth() + 1).toString().padStart(2, "0");
            const date = time.getDate().toString().padStart(2, "0");
            const hours = time.getHours().toString().padStart(2, "0");
            const minute = time.getMinutes().toString().padStart(2, "0");
            const second = time.getSeconds().toString().padStart(2, "0");

            return (
                year +
                "年" +
                month +
                "月" +
                date +
                "日" +
                hours +
                "时" +
                minute +
                "分"
            );
        },
        roomNumber(index) {
            return getRoom(index)
        },
    },
    destroyed: function () {
        this.$storage.removeStorage("antMap");
    },
    created() {
        let that = this;
        if (this.$storage.getStorage("antMap") != false) {
            this.data.nNavindex = this.$storage.getStorage("antMap");
        } else {
            this.data.nNavindex = 0;
        }
        $init((res) => {
            that.getImages();
        });
    },
    methods: {
        onInput(e) {
            this.num = (e / (100 / 6) + 1).toFixed(0);
        },
        comen() {
            if (this.nNum != this.num) {
                this.nNum = this.num;
                this.nValue = this.value;
                this.bComen = true;
            }
            this.data.bShowTips = false;
            let data = {
                report_id: this.$route.query.reportid,
                day: this.nNum,
                type: 1,
            };
            this.$store.commit("loadSwitch", true);
            detail.getPdfShare(data).then((res) => {
                this.nKey = res.result.key;
                let confit = {
                    share_friend_title: "请查阅您的专属定制方案",
                    share_friend_desc:
                        this.data.reporInfo.address +
                        "AI-LiNK冷暖风水专业集成系统定制方案",
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${this.$route.query.reportId}&from=share&nKey=${this.nKey}`,
                };
                this.confit = confit;
                //jssdk
                this.wxStare(confit);
                this.$store.commit("loadSwitch", false);
                if (this.$storage.getStorage("is_wechat") == 1) {
                    // 微信环境下
                    this.wxShareShow = true;
                } else if (this.$storage.getStorage("is_wechat") == 6) {
                    // 企业微信环境下
                    this.data.bShowNrom = true;
                }
            });
        },
        canler() {
            if (this.nNum != this.num && this.bComen) {
                this.num = this.nNum;
                this.value = this.nValue;
            } else if (!this.bComen) {
                this.num = 7;
                this.value = 100;
            }
            this.data.bShowTips = false;
        },


        //跳转生成pdf
        getPdf() {
            this.$router.push({
                path: `/pdf/pdfindex?reportId=${this.$route.query.reportId}`,
            });
        },
        //报价单
        getCheck() {
            let that = this;
            detail
                .getCheck({ report_id: that.$route.query.reportId })
                .then((res) => {
                    let objOffer = res.result;
                    objOffer.arrInfo = [];
                    if(objOffer.constructor != Array && objOffer.info.length){
                        objOffer.info.forEach((it, index) => {
                            if (it.goods.length != 0) {
                                objOffer.arrInfo.push(it);
                            }
                        });
                    }
                    that.data.objOffer = objOffer;
                });
        },
        //用户信息
        getUserInfo() {
            let that = this;
            detail.getInfo().then((res) => {
                that.data.oUserInfo = res.result;
                let from = that.$route.query.from; //判断用户是否是分享出去的
                if (from != undefined) {
                    this.$storage.removeStorage("antMap");
                    that.data.bShowCard = true;
                } else {
                    that.data.bShowCard = false;
                }
                //判断用户是否是分享进来，用户有无同意隐私协议
                if (res.result.is_agree == 0 && from != undefined) {
                    that.data.bAgree = true;
                } else {
                    that.data.bAgree = false;
                }
            });
        },

        //隐私协议
        getAgree() {
            let that = this;
            detail.getAgree({ code: "user_rule", html: 0 }).then((res) => {
                //  console.log("隐秘协议", res);
                that.data.objSmcode = res.result;
            });
        },
        clickPlay() {
            this.data.bShowVideo = false;
            var video = document.getElementById("ckplayer_a1");
            video.currentTime = 0;
            video.play();
        },
        getGd() {
            this.data.nRoomNumber = this.data.reporInfo.sub.length;
        },
        getSqgd() {
            this.data.nRoomNumber = 1;
        },
        getImages() {
            let that = this;
            // for (let img of arrImage) {
            let image = new Image();
            image.src = arrImage[that.data.count];
            image.onload = () => {
                that.data.count++;
                // 计算图片加载的百分数，绑定到percent变量
                let percentNum = Math.floor(
                    (that.data.count / arrImage.length) * 100
                );
                // this.percent = `${percentNum}%`;
                that.data.nLoading = percentNum;
                if (that.data.count == arrImage.length) {
                    that.$store.commit("loadSwitch", true);
                    Promise.all([
                        that.getVrList(),
                        that.getPoslists(),
                        that.getReportinfo(),
                        that.getAgree(),
                        that.getUserInfo(),
                        that.getCheck(),
                    ]).then((res) => {
                        setTimeout(() => {
                            that.data.bLoading = false;
                        }, 800);
                        if (this.$route.query.nKey) {
                            detail
                                .getPdfShareInfo({ key: this.$route.query.nKey })
                                .then((res) => {
                                    wx.ready(() => {
                                        wx.hideOptionMenu();
                                    });
                                    this.nKey = res.result.key;
                                    let keyTime = res.result.expire_at.replace(/\-/g, "/");
                                    let dateEndTime = new Date(keyTime).getTime();
                                    let currentTime = new Date().getTime();
                                    if(currentTime>=dateEndTime){
                                        this.nState = 0;
                                    }else{
                                        this.nState = 1;
                                    }
                                    this.endTime = res.result.expire_at;
                                });
                        } else {
                            //获取默认7天的key
                            let data = {
                                report_id: this.$route.query.reportId,
                                day: 7,
                                type: 1,
                            };
                            detail.getPdfShare(data).then((res) => {
                                this.nKey = res.result.key;
                            });
                        }



                        //获取播放器元素
                        this.$nextTick(() => {
                            var u = navigator.userAgent;
                            var isAndroid =
                                u.indexOf("Android") > -1 ||
                                u.indexOf("Linux") > -1; // Android
                            var isIOS = !!u.match(
                                /\(i[^;]+;( U;)? CPU.+Mac OS X/
                            ); // ios
                            if (isAndroid) {
                                this.data.bShowVideo = true;
                            }
                            if (isIOS) {
                                this.bIpone = true;
                                this.data.bShowVideo = false;
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    function () {
                                        var video =
                                            document.getElementById(
                                                "ckplayer_a1"
                                            );
                                        video.play();
                                    },
                                    false
                                );
                                // document.addEventListener(
                                //     "touchstart",
                                //     function () {
                                //         let video =
                                //             document.getElementById(
                                //                 "ckplayer_a1"
                                //             );
                                //         console.log("用户触摸了屏幕", video);
                                //         video.play();
                                //     },
                                //     false
                                // );
                            }
                        });
                    });
                } else {
                    that.getImages();
                }
            };
            image.onerror = () => {
                //  console.log('加载失败',this.data.count)
                this.data.bShowBtn = true;
            };
            // }
        },
        //重新加载图片
        cXlogin() {
            this.data.bShowBtn = false;
            this.data.count = 0;
            this.data.nLoading = 0;
            this.getImages();
        },
        //jssdk 微信分享
        wxStare(config) {
            getWxSingleConfig(config);
        },
        //推荐案例
        getRanks(city_id) {
            let that = this;
            detail.getRanks({ cityId: city_id }).then((res) => {
                let arrRanks = res.result;
                that.data.arrRanks = arrRanks;
            });
        },
        //点击导航获取子标签的索引值
        getRoomfu(e) {
            this.data.nRooms = e;
        },
        //提交获取子标签的值
        sumbit(e) {
            //子组件提交成功
            //category==0默认 category==1为水系统  category==2 为新风系统   category==3  为ailink系统
            if (!e.nMark && e.tag_id == 0) {
                this.data.reporInfo.tags[e.nIndex].type_desc = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 1) {
                this.data.reporInfo.tags[e.nIndex].strDeas = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 2) {
                this.data.reporInfo.tags[e.nIndex].strDeasFreshs = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 3) {
                this.data.reporInfo.tags[e.nIndex].strDeasAilink = e.eaitDeas;
            } else if (e.nMark&&e.nType == 0) {
                this.data.reporInfo.mark = e.eaitDeas;
            }else if (e.nMark&&e.nType == -1) {
                this.data.reporInfo.mark_extra = e.eaitDeas;
            }
        },
        //点击末端选项
        getEnd() {
            this.data.bShowEnd = true;
        },
        //拼接字符
        arrStr(arr, connectStr) {
            var str = "";
            let nStar = 0;
            //遍历数组
            arr.forEach((ele) => {
                nStar++;
                if (nStar == arr.length) {
                    str += ele;
                } else {
                    str += ele + String(connectStr);
                }
            });
            return str;
        },
        //获取方案书详情
        getReportinfo() {
            let that = this;
            let reportData = {
                // user_id:'192',
                report_id: that.$route.query.reportId,
                show_sub: 1, //子报告
                show_room: 1, //房间信息
                show_attach: 1, //附件信息
                show_product_type: 1, //产品类型
                show_product: 1, //方案商品
                show_tag: 1, //标签信息
                show_common: 1, //通用信息
                chunk_room_product: 1, //房间数量是否根据风盘拆分
                show_card: 1, //获取名片
                qr_code: 1, //转化二维码
            };
            that.$store.commit("loadSwitch", true);
            detail.getReportinfo(reportData).then((res) => {
                //  console.log("报告详情", res);
                let reporInfo = res.result;
                let local_user_id = that.$storage.getStorage("user_id");
                if (reporInfo.card.constructor != Array) {
                    this.data.bCard = true; //是否显示名片
                    //  console.log(reporInfo.card.constructor != Array);
                } else {
                    this.data.bCard = false; //是否显示名片
                }
                let confit = {
                    share_friend_title: "请查阅您的专属定制方案",
                    share_friend_desc:
                        reporInfo.address +
                        "AI-LiNK冷暖风水专业集成系统定制方案",
                    share_img_url:
                        "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_img.png",
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}?reportId=${that.$route.query.reportId}&from=share&nKey=${this.nKey}`,
                };
                that.data.confit = confit;
                //jssdk
                that.wxStare(confit);
                //根据城市推荐案例
                reporInfo.bShowCard = that.data.bShowCard;
                that.getRanks(reporInfo.city_id);
                reporInfo.arrDeaFreshs = [];
                reporInfo.arrSub = []; //冷暖系统楼层
                reporInfo.arrFreshsSub = []; //风盘楼层
                reporInfo.arrWaterSub = []; //水系统楼层
                reporInfo.arrAliinkSub = []; //alilink 楼层
                reporInfo.arrProduct = []; //轻奢系列套餐
                reporInfo.water_soft = 0; //总最大软水用量
                reporInfo.water_clean = 0; //总最大软水用量
                reporInfo.water_energy = 0; //热水需求负荷
                reporInfo.water_rate = 0; //热水设计流量
                //附件循环push到固定轮播图前面
                reporInfo.goods_album.forEach((item) => {
                    item.imgname = "";
                });
                reporInfo.attach.forEach((item) => {
                    reporInfo.goods_album.unshift({
                        img: item.items[0],
                        imgname: item.name,
                    });
                });
                // 套餐报价
                reporInfo.product.forEach((res) => {
                    res.attr_one = []; // 右边重要卖点
                    res.attr_two = []; // 下面参数
                    res.attr_three = []; //末端选项参数
                    getAttr(res.attr,res.attr_one,res.attr_two,res.attr_three,res)
                    reporInfo.arrProduct.unshift(res);
                });
                //人员需求是否选择老人小孩女士
                let arrPersonnel = reporInfo.config_ids.split(",");
                let strPersonnel = "";
                arrPersonnel.forEach((it) => {
                    if (it == 55) {
                        if (strPersonnel == "") {
                            strPersonnel = "高龄老人";
                        } else {
                            strPersonnel = strPersonnel + "、高龄老人";
                        }
                    } else if (it == 56) {
                        if (strPersonnel == "") {
                            strPersonnel = "体弱女性";
                        } else {
                            strPersonnel = strPersonnel + "、体弱女性";
                        }
                    } else if (it == 57) {
                        if (strPersonnel == "") {
                            strPersonnel = "年幼儿童";
                        } else {
                            strPersonnel = strPersonnel + "、年幼儿童";
                        }
                    }
                });
                //系统定制需求
                let arrColstDeas = [];
                reporInfo.tags.forEach((tag) => {
                    tag.arrColstDeas = arrColstDeas;
                    tag.arrDeas = [];
                    tag.arrWater = []; //水系统里面的人员需求
                    tag.arrFreshs = []; //新风系统的人员需求
                    tag.arrAilink = []; //ailink的人员需求
                    tag.arrXiaji = []; //冬季需求
                    tag.arrHuasa = []; //水系统里面的花洒
                    tag.name = "";
                    tag.nameClass = "";
                    if (tag.type == 1) {
                        tag.name = "作息需求";
                        tag.nameClass = "two_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.tag_id != 31) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                            if (des.desc != "" && des.tag_id == 31) {
                                reporInfo.warm_state_text = des.name;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 2 || tag.type == 3) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        tag.items.forEach((des) => {
                            if (
                                (des.desc == "" &&
                                    (des.tag_id == 31 ||
                                        des.id == 64 ||
                                        des.id == 82 ||
                                        des.id == 61,
                                    62,
                                    63)) ||
                                (des.id != 65 && des.tag_id == 38) ||
                                (des.id == 108 && des.tag_id == 33)
                            ) {
                            } else {
                                if (des.id == 84) {
                                    des.desc =
                                        des.desc + "，家中有" + strPersonnel;
                                }
                                arrColstDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        this.$nextTick(() => {
                            let strDeas = this.arrStr(
                                tag.arrColstDeas,
                                "<br/>"
                            );
                            tag.strDeas =
                                strDeas +
                                "为了保证身体健康，冬季需要更温暖的室内环境";
                        });
                    }
                    if (tag.type == 5) {
                        tag.name = "冬季室温需求";
                        tag.nameClass = "three_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.tag_id != 31) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 4) {
                        tag.name = "夏季室温需求";
                        tag.nameClass = "four_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.id == 85) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 3) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        //拼接文字
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.id == 64) {
                                tag.arrWater.push("*" + des.desc);
                                tag.tag_id = des.id;
                            }
                            if (des.desc != "" && des.id == "61,62,63") {
                                tag.arrFreshs.push("*" + des.desc);
                                tag.tag_freshs_id = des.id;
                            }
                            if (des.desc != "" && des.id == 65) {
                                tag.arrAilink.push("*" + des.desc);
                                tag.tag_ailink_id = des.id;
                            }
                            if (des.desc != "" && des.id == 83) {
                                tag.arrXiaji.push("*" + des.desc);
                            }
                            if (des.desc != "" && des.id == 108) {
                                tag.arrHuasa.push("*" + des.desc);
                                tag.tag_huasa_id = des.id;
                            }
                        });
                        // tag.strDeas = strDeas;
                        //拼接文字
                        let strHuasa = this.arrStr(tag.arrHuasa, "<br/>");
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        let arrWater = this.arrStr(tag.arrWater, "<br/>");
                        let strDeasFreshs = this.arrStr(tag.arrFreshs, "<br/>");
                        let strDeasAilink = this.arrStr(tag.arrAilink, "<br/>");
                        if (strDeasAilink == "") {
                            this.data.bShowText = false;
                        }
                        if (strDeasFreshs == "") {
                            this.data.bShowFreshsText = false;
                        }
                        if (arrWater == "") {
                            this.data.bShowWaterText = false;
                        }
                        tag.strHuasa = strHuasa;
                        tag.arrWater = arrWater;
                        tag.strDeas = strDeas;
                        tag.strDeasFreshs = strDeasFreshs;
                        tag.strDeasAilink = strDeasAilink;
                    }
                });
                let numToilet = 0; //卫生间数量
                let numKitchen = 0; //厨房数量
                let numWindKou = 0; //风口数量
                let numHqcs = 0; //换气次数
                let arrNumHqcs = []; //换气数组
                let numFreshs = 0; //新风风量
                let numWindArea = 0; //换气面积
                let arrDeaFreshs = []; //新风系统
                let arrDeaAilink = []; //Allink
                let arrDeaWater = []; //水系统
                let arrDeaCod = []; //冷暖系统
                reporInfo.sub.forEach((it) => {
                    it.arrWater = []; //水系统
                    it.arrCodsystem = []; //冷暖系统
                    it.arrFreshs = []; //新风系统
                    it.arrAilink = []; //Ailink
                    it.arrProther = []; //除Ailink外所有系统报价商品
                    if (it.product.length) {
                        it.product.forEach((aet) => {
                            if (aet.level == 0) {
                                aet.items.forEach((item) => {
                                    item.items.forEach((sys) => {
                                        sys.items.forEach((ad) => {
                                            ad.attr_three = []; //末端选项参数
                                            ad.attr.forEach((ib) => {
                                                ib.attr_name =
                                                    ib.attr_name.replace(
                                                        /[\ +\r\n]/g,
                                                        ""
                                                    );
                                                if (ib.attr_mean > 3) {
                                                    ad.attr_three.push(ib);
                                                }
                                            });
                                        });
                                    });
                                    if (item.system_id == 1) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                if (
                                                    ad.new_goods_type_id ==
                                                        215 ||
                                                    ad.new_goods_type_id == 216
                                                ) {
                                                } else {
                                                    it.arrCodsystem.push(ad);
                                                }
                                            });
                                            if (sys.items.length > 0) {
                                                //  console.log(it);
                                                reporInfo.arrSub.push(it);
                                            }
                                        });
                                        //判断是否为冷暖系统，然后数组去重
                                        reporInfo.arrSub = noRepeat(
                                            reporInfo.arrSub,"room"
                                        );
                                    }
                                    if (item.system_id == 3) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrFreshs.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrFreshsSub.push(it);
                                            }
                                        });
                                        //判断是否为风盘系统，然后数组去重
                                        reporInfo.arrFreshsSub = noRepeat(
                                            reporInfo.arrFreshsSub,"room"
                                        );
                                    }
                                    if (
                                        item.system_id == 4 ||
                                        item.system_id == 2
                                    ) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrWater.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrWaterSub.push(it);
                                            }
                                        });
                                        //判断是否为水系统，然后数组去重
                                        reporInfo.arrWaterSub = noRepeat(
                                            reporInfo.arrWaterSub,"room"
                                        );
                                    }
                                    if (item.system_id == 5) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrAilink.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrAliinkSub.push(it);
                                            }
                                        });
                                        //判断是否为Alink系统，然后数组去重
                                        reporInfo.arrAliinkSub = noRepeat(
                                            reporInfo.arrAliinkSub,"room"
                                        );
                                        //  console.log(reporInfo.arrAliinkSub);
                                    } else {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrProther.push(ad);
                                            });
                                        });
                                    }
                                });
                                it.arrFreshs.forEach((ie) => {
                                    arrDeaFreshs.push(ie);
                                });
                                it.arrAilink.forEach((ie) => {
                                    arrDeaAilink.push(ie);
                                });
                                it.arrWater.forEach((ie) => {
                                    arrDeaWater.push(ie);
                                });
                                it.arrCodsystem.forEach((ie) => {
                                    arrDeaCod.push(ie);
                                });
                                arrDeaWater = noRepeat(arrDeaWater,"shopp");
                            }
                        });
                        //用文字匹配需要用的重要参数
                        // 冷暖系统
                        it.arrCodsystem.forEach((ia) => {
                            ia.attr_one = []; // 右边重要卖点
                            ia.attr_two = []; // 需要展示的重要参数
                            ia.attr_three = [];
                            getAttr(ia.attr,ia.attr_one,ia.attr_two,ia.attr_three,ia)
                        });
                        //水系统
                        it.arrWater.forEach((ia) => {
                            ia.attr_one = []; // 右边重要卖点
                            ia.attr_two = []; // 需要展示的重要参数
                            ia.attr_three = [];
                            getAttr(ia.attr,ia.attr_one,ia.attr_two,ia.attr_three,ia)
                        });
                        //循环房间
                        it.rooms.forEach((room, index) => {
                            room.openId = index;
                            room.open = true;
                            room.product.forEach((sh) => {
                                sh.attr_one = []; // 右边重要卖点
                                sh.attr_two = []; // 下面参数
                                sh.attr_three = []; //末端选项参数
                                getAttr(sh.attr,sh.attr_one,sh.attr_two,sh.attr_three,sh)
                                reporInfo.numWindKou = numWindKou += Number(
                                    sh.num
                                );
                            });
                        });
                    }
                    //计算厨房卫生间
                    reporInfo.numFreshs = numFreshs += Number(it.wind_energy);
                    reporInfo.numHqcs = numHqcs += Number(it.wind_exchange); //换气次数
                    arrNumHqcs.push(it.wind_exchange);
                    reporInfo.numChishu = Math.max(...arrNumHqcs);
                    reporInfo.numToilet = numToilet += it.num_toilet;
                    reporInfo.numKitchen = numKitchen += it.num_kitchen;
                    reporInfo.numWindArea = numWindArea += Number(it.wind_area);
                    reporInfo.water_soft = reporInfo.water_soft += Number(
                        it.water_soft
                    ); //总最大软水用量
                    reporInfo.water_clean = reporInfo.water_clean += Number(
                        it.water_clean
                    ); //总最大软水用量
                    reporInfo.water_energy = reporInfo.water_energy += Number(
                        it.water_energy
                    ); //热水需求负荷
                    reporInfo.water_rate = reporInfo.water_rate += Number(
                        it.water_rate
                    ); //热水设计流量
                });
                //系统报价
                let arrSysterm = [
                    { title: "Step1冷暖风水系统设备", sub: reporInfo.sub },
                    { title: "Step2末端设备", sub: reporInfo.sub },
                    { title: "Step3控制系统", sub: reporInfo.sub },
                ];
                arrDeaFreshs.forEach((it) => {
                    // 新风系统
                    it.attr_one = []; // 右边重要卖点
                    it.attr_two = []; // 需要展示的重要参数
                    it.attr_three = [];
                    getAttr(it.attr,it.attr_one,it.attr_two,it.attr_three,it)
                });
                arrDeaAilink.forEach((it) => {
                    // Ai_link
                    it.attr_one = []; // 右边重要卖点
                    it.attr_two = []; // 需要展示的重要参数
                    it.attr_three = [];
                    getAttr(it.attr,it.attr_one,it.attr_two,it.attr_three,it)
                });
                reporInfo.arrSysterm = arrSysterm;
                reporInfo.arrDeaAilink = arrDeaAilink;
                reporInfo.arrDeaFreshs = arrDeaFreshs;
                reporInfo.arrDeaWater = arrDeaWater;
                reporInfo.arrDeaCod = arrDeaCod;
                reporInfo.arrSwiperImg = that.data.arrSwiperImg;
                //  console.log(arrDeaFreshs.length == 0);
                if (arrDeaAilink.length == 0) {
                    that.data.arrErnav.splice(3, 1);
                }
                if (arrDeaFreshs.length == 0) {
                    that.data.arrErnav.splice(2, 1);
                }
                if (arrDeaWater.length == 0) {
                    that.data.arrErnav.splice(1, 1);
                }
                if (arrDeaCod.length == 0) {
                    that.data.arrErnav.splice(0, 1);
                }
                that.data.reporInfo = reporInfo;
                that.$store.commit("loadSwitch", false);
            });
        },
        //获取广告位
        getPoslists() {
            let that = this;
            let poslistsData = {
                pos_id: 6,
            };
            that.$store.commit("loadSwitch", true);
            detail.getPoslists(poslistsData).then((res) => {
                that.data.arrPos = res.result;
                that.$store.commit("loadSwitch", false);
            });
        },
        // 获取vr
        getVrList() {
            this.$store.commit("loadSwitch", true);
            detail.getVrList().then((res) => {
                this.$store.commit("loadSwitch", false);
                this.data.arrVrList = res.result;
            });
        },
        //奉贤
        getShare() {
            if (this.$route.query.nKey) {
                this.$toast("禁止分享~");
                return false;
            }
            this.data.bShowTips = true;
        },
        //点击系统选项卡
        getPoints(index) {
            this.data.bShowVideo = false;
            this.data.nPoints = index;
            this.data.nBright = 0;
            if (index == 1) {
                this.arrBright = [
                    { name: "一键互联", className: "" },
                    { name: "多个场景化", className: "" },
                    { name: "全联全控", className: "" },
                ];
            } else if (index == 0) {
                this.arrBright = [
                    { name: "热浪", className: "heat" },
                    { name: "速热", className: "speed" },
                    { name: "节能", className: "energy" },
                ];
            }
        },
        getBright(index) {
            this.data.bShowVideo = false;
            this.data.nBright = index;
        },
        //点击一级导航
        getNav(index) {
            this.data.bShow = true;
            this.$storage.setStorage("antMap", index);
            this.data.nNavindex = index;
        },
        getAtcStrBottom(index, boIndex) {
            this.getScrollTop(0, 200);
            this.data.secondIndex = index;
            this.data.bottomIndex = boIndex;
        },
        //点击二级导航
        getAtcStr(index, boIndex) {
            this.data.bShow = true;
            this.data.bottomIndex = boIndex;
            this.data.secondIndex = index;
        },
        //滚动条滚动
        getScrollTop(number = 0, time) {
            let that = this;
            if (!time) {
                document.body.scrollTop = document.documentElement.scrollTop =
                    number;
                return number;
            }
            const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
            let spacingInex = time / spacingTime; // 计算循环的次数
            let nowTop =
                document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
            let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
            let scrollTimer = setInterval(() => {
                if (spacingInex > 0) {
                    spacingInex--;
                    that.getScrollTop((nowTop += everTop));
                } else {
                    clearInterval(scrollTimer); // 清除计时器
                }
            }, spacingTime);
        },
    },
};
</script>
<style lang="scss" scoped>
.zh_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.share_btn {
    width: 300px;
    height: 80px;
    border-radius: 40px;
    border: solid 2px #318544;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #318544;
    margin: 48px auto 0;
}

.child-view {
    /*background: #F0F4F1!important;*/
}
@import "index.scss";
</style>
